module.exports = new __parcel__URL__("your-work-app-skeleton.tpl.14d150b5.svg").toString();